import { render, staticRenderFns } from "./BillingChargeTypeBadge.vue?vue&type=template&id=1bf40aef"
import script from "./BillingChargeTypeBadge.vue?vue&type=script&lang=js"
export * from "./BillingChargeTypeBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports